import {DayOfWeekListVo} from '../../common/shared/api/karina/vo/dayOfWeek/DayOfWeekListVo.interface';
import {
  BannerViewType,
  DayOfWeekList,
  ItemType,
  MetaInfoType,
} from '../generated/types';
import {createBannerItem} from './BannerItem';
import {createCardViewItem} from './CardViewItem';

export const createDayOfWeekList = (
  data: DayOfWeekListVo,
  sortType?: string
): DayOfWeekList => {
  return {
    title: data.title,
    list: data.list.map(item =>
      createCardViewItem(null, {
        itemSeriesDto: item,
        metaInfoType:
          sortType === 'view_count'
            ? MetaInfoType.ViewCount
            : sortType === 'rating'
              ? MetaInfoType.Rating
              : MetaInfoType.AuthorName,
      })
    ),
    banner: data.banner
      ? createBannerItem({
          item: data.banner,
          itemType: ItemType.Banner,
          viewType: BannerViewType.Rectangle,
        })
      : undefined,
    isEnd: data.is_end,
  };
};
